import {
  getScreenV2ByIndexIdGetLayer,
  findOrgCompanyNumByType
} from "@/api/granary";
import { findOrgCompanyByType } from "@/api/map";
import { findIndexByName } from "@/util/index";
import { get } from "@/api/index";
import * as L from "leaflet";
import cDetail from "@/views/granary/map/util/zzdhDetail";
import mm5geoData from "@/views/granary/map/util/mm5s-geo.json";
const legendColor = ["#008c5a", "#8cc24e", "#f5fe4c", "#da8c00", "#d65c01"];
// 通用涉农企业 处理
export const snqyMixin = {
  components: {
    cDetail
  },
  data() {
    return {
      mode: -1,
      curName: "",
      nowZoom: 0,
      lockload: false, // 主动加载时无需重新加载
      mm5ditu: null // 茂名5市底图层
    };
  },
  watch: {
    nowZoom(val, oldVal) {
      console.log("new,old", val, oldVal);
      if (oldVal === 0 || val === 0) {
        if (this.curName === "农资经营企业") {
          this.snqyDataload(6);
        }
      }
      if (oldVal === 3 || val === 3) {
        if (this.lockload) {
          this.lockload = false;
          return;
        }
        console.log("in 生产基地");
        if (this.curName === "生产基地") {
          this.snqyDataload(7);
        }
      }
    }
  },
  methods: {
    snqyDataload(mode) {
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
        this.baseList = [];
      }
      this.mode = mode;
      if (mode === 3) {
        getScreenV2ByIndexIdGetLayer("5c56324cda4443fe99029b4d546dc07d").then(
          data => {
            data.data.map(ele => {
              ele.latitude = Number(ele.latitude);
              this.baseList.push(ele);
            });
            this.snqy_baseLoad_h("ltqy.png", false);
          }
        );
      } else if (mode === 4) {
        getScreenV2ByIndexIdGetLayer("cc2ecf9c1ded4654b8fb31ec7da5047c").then(
          data => {
            data.data.map(ele => {
              ele.latitude = Number(ele.latitude);
              this.baseList.push(ele);
            });
            this.snqy_baseLoad_h("hzs.png", false);
          }
        );
      } else if (mode === 5) {
        //家庭农场
        if (this.nowZoom < 3) {
          findOrgCompanyNumByType("3").then(data => {
            this.creategeoDt(data.data);
            // data.data.map(ele => {
            //   ele.name = ele.country_ + ":" + ele.num;
            //   ele.latitude = Number(ele.latitude_);
            //   ele.longitude = Number(ele.longitude_);
            //   this.baseList.push(ele);
            // });
            // this.snqy_baseLoad("jtnc.png", true);
          });
        }
      } else if (mode === 6) {
        //农资经营企业
        if (this.nowZoom === 0) {
          findOrgCompanyNumByType("5").then(data => {
            this.creategeoDt(data.data);
            // old show point
            // data.data.forEach(ele => {
            //   ele.name = ele.country_ + ":" + ele.num;
            //   ele.latitude = Number(ele.latitude_);
            //   ele.longitude = Number(ele.longitude_);
            //   this.baseList.push(ele);
            // });
            // this.snqy_baseLoad("nzjyqy.png", false);
          });
        } else {
          findOrgCompanyByType({ type: 5 }).then(data => {
            this.cleargeoDt();
            data.data.map(ele => {
              this.baseList.push(ele);
            });
            this.snqy_baseLoad_h("nzjyqy.png", true);
          });
        }
      } else if (mode === 7) {
        //生产基地
        if (this.nowZoom < 3) {
          findOrgCompanyNumByType("6").then(data => {
            console.log("data ==", data.data);
            let arr = [];
            data.data.forEach(ele => {
              ele.name = ele.country_ + ":" + ele.num;
              ele.latitude = Number(ele.latitude_);
              ele.longitude = Number(ele.longitude_);
              arr.push(ele);
              //   this.baseList.push(ele);
            });
            arr.sort(function (x, y) {
              return x["num"] - y["num"];
            });
            console.log("arr sort ==", arr);
            //add color & create geojson
            let geoarr = [];
            arr.forEach((e, i) => {
              e.color = legendColor[i] || "#57e3f4";
              const index = findIndexByName(
                e.country_,
                mm5geoData.features,
                "properties",
                "NAME"
              );
              if (index > -1) {
                const obj = mm5geoData.features[index];
                Object.assign(obj.properties, e);
                geoarr.push(obj);
              }
            });
            console.log("geoarr ===", geoarr);
            // 加载 geo 5区域地图
            this.loadgeoDt({ type: "FeatureCollection", features: geoarr });
            // this.snqy_baseLoad("scjd.png", true);
          });
        } else {
          findOrgCompanyByType({ type: 6 }).then(data => {
            this.cleargeoDt();
            data.data.map(ele => {
              this.baseList.push(ele);
            });
            this.snqy_baseLoad_h("scjd.png", true);
          });
        }
      }
    },
    // 涉农企业数据加载
    snqy_baseLoad(img = "ycyp.png", hasclick = true) {
      this.jdArr = [];
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
      }
      this.basesGroup = new L.layerGroup();
      let pointUrl = require("images/map/" + img);
      this.baseList.map(it => {
        if (it.latitude) {
          it.lat = it.latitude;
          it.lng = it.longitude;
          //   let pointUrl = require("images/map/" + it.img);
          var myIcons;

          myIcons = L.divIcon({
            html:
              "<div class='indicator-box'><img src='" +
              pointUrl +
              "' /><span class='my-div-names'>" +
              it.name +
              "</span ></div>",
            className: "my-div-icon",
            iconAnchor: this.baseAnchor
          });

          let baseLayer = L.marker([it.lat, it.lng], {
            interactive: true,
            icon: myIcons,
            attributes: it
          }).addTo(this.basesGroup);
          this.jdArr.push(baseLayer);
          if (hasclick) {
            baseLayer.on("click", e => {
              const dt = e.sourceTarget.options.attributes;
              console.log("data ==", dt);
              if (this.mode == 7 || this.mode == 5) {
                // 主动放大
                let type = 6;
                if (this.mode == 5) {
                  type = 3;
                }
                if (dt.country_) {
                  findOrgCompanyByType({
                    type: type,
                    name: dt.country_
                  }).then(data => {
                    this.baseList = []; //清空旧的数据
                    data.data.map(ele => {
                      this.baseList.push(ele);
                    });
                    this.lockload = true;
                    this.map.setView(L.latLng(dt.latitude, dt.longitude), 3);
                    this.snqy_baseLoad_h("clz.png", true);
                  });
                }
              }
              // 显示信息卡
              //   if (data.tc_pic) {
              //     console.log(
              //       "window.__config.VUE_APP_IMG_URL",
              //       window.__config.VUE_APP_IMG_URL
              //     );
              //     this.$bus.$emit("ImageViewer", [
              //       window.__config.VUE_APP_IMG_URL + data.tc_pic
              //     ]);
              //   }
            });
          }
        }
      });
      this.map.addLayer(this.basesGroup);
    },
    //涉农企业数据加载, 默认hide
    snqy_baseLoad_h(img = "ycyp.png", hasclick = true) {
      this.jdArr = [];
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
      }
      this.basesGroup = new L.layerGroup();
      let pointUrl = require("images/map/" + img);
      this.baseList.map(it => {
        if (it.latitude) {
          it.lat = it.latitude;
          it.lng = it.longitude;
          //   let pointUrl = require("images/map/" + it.img);
          var myIcons;

          myIcons = L.divIcon({
            html:
              "<div class='indicator-box'><img src='" +
              pointUrl +
              "' /><span class='my-div-names hide'>" +
              it.name +
              "</span ></div>",
            className: "my-div-icon",
            iconAnchor: this.baseAnchor
          });

          let baseLayer = L.marker([it.lat, it.lng], {
            interactive: true,
            icon: myIcons,
            attributes: it
          }).addTo(this.basesGroup);
          this.jdArr.push(baseLayer);
          if (hasclick) {
            baseLayer.on("click", e => {
              const data = e.sourceTarget.options.attributes;

              this.poisiton = {};
              let obj = {};
              obj.x = e.containerPoint.x;
              obj.y = e.containerPoint.y;
              let chkArr, url;
              if (data.name) {
                if (this.mode == 5) {
                  chkArr = [
                    {
                      key: "address_",
                      name: "地址"
                    },
                    {
                      key: "username_",
                      name: "农场主姓名"
                    },
                    {
                      key: "idCard_",
                      name: "身份证号"
                    },
                    {
                      key: "phone_",
                      name: "手机号"
                    },
                    {
                      key: "type_",
                      name: "农场经营类型"
                    },
                    {
                      key: "gd_area_",
                      name: "耕地面积",
                      unit: "亩"
                    },
                    {
                      key: "zl_area_",
                      name: "种粮面积",
                      unit: "亩"
                    },
                    {
                      key: "ld_area_",
                      name: "林地面积",
                      unit: "亩"
                    },
                    {
                      key: "cd_area_",
                      name: "草地面积",
                      unit: "亩"
                    },
                    {
                      key: "sm_area_",
                      name: "水面面积",
                      unit: "亩"
                    },
                    {
                      key: "other_area_",
                      name: "其他土地情况",
                      unit: "亩"
                    },
                    {
                      key: "year_",
                      name: "经营年度"
                    },
                    {
                      key: "income_",
                      name: "年度总收入",
                      unit: "万元"
                    },
                    {
                      key: "sfnc_",
                      name: "示范农场"
                    },
                    {
                      key: "gsjzc_",
                      name: "是否在工商局注册"
                    },
                    {
                      key: "ifZcsb_",
                      name: "是否有注册商标"
                    },
                    {
                      key: "fRz_",
                      name: "是否通过农产品质量认证"
                    },
                    {
                      key: "fc_year_",
                      name: "获得各级财政扶持资金年度"
                    },
                    {
                      key: "fczj_",
                      name: "获得各级财政扶持资金金额",
                      unit: "万元"
                    }
                  ];
                  url = "/api/restful/findOrgCompanyNcByName";
                } else if (this.mode == 6) {
                  chkArr = [
                    {
                      key: "manager_",
                      name: "负责人"
                    },
                    {
                      key: "phone_",
                      name: "负责人电话"
                    },
                    {
                      key: "linkMan_",
                      name: "联系人"
                    },
                    {
                      key: "linkPhone_",
                      name: "联系人电话"
                    },
                    {
                      key: "address_",
                      name: "所在地区"
                    },
                    {
                      key: "series_",
                      name: "经营许可证号"
                    },
                    {
                      key: "company_",
                      name: "发证机关"
                    },
                    {
                      key: "validDate_",
                      name: "发放日期"
                    },
                    {
                      key: "scope_",
                      name: "经营范围"
                    }
                  ];
                  url = "/api/restful/sy/detail";
                } else if (this.mode == 7) {
                  chkArr = [
                    {
                      key: "area_",
                      name: "面积"
                    },
                    {
                      key: "cl_",
                      name: "年产量"
                    },
                    {
                      key: "main _plant_",
                      name: "主要种植品种"
                    },
                    {
                      key: "cb_",
                      name: "承包"
                    },
                    {
                      key: "manage_",
                      name: "管理情况"
                    },
                    {
                      key: "sale_",
                      name: "电商销售量"
                    },
                    {
                      key: "phone_",
                      name: "联系方式"
                    },
                    {
                      key: "level_",
                      name: "经营主体级别"
                    },
                    {
                      key: "brand_",
                      name: "商标、品牌"
                    },
                    {
                      key: "town_",
                      name: "所在镇区"
                    },
                    {
                      key: "village_",
                      name: "村委名称"
                    },
                    {
                      key: "desc_",
                      name: "备注"
                    }
                  ];
                  url = "/api/restful/findOrgCompanyGyByName";
                }

                get(url, { name: data.name }).then(res => {
                  console.log("get data =", res);
                  const _d = res.data;
                  let arr = [];

                  if (_d instanceof Array) {
                    if (_d.length === 0) {
                      return;
                    }
                    obj.name = _d[0].name_;
                    chkArr.forEach(e => {
                      if (_d[0][e.key]) {
                        arr.push({
                          name: e.name,
                          num: _d[0][e.key],
                          unit: e.unit || ""
                        });
                      }
                    });
                    obj.dataList = arr;
                    this.poisiton = obj;
                  }
                });
              }
            });
          }
          baseLayer.on("mouseover", it => {
            console.log("it", it.target.options.attributes);
            it.sourceTarget
              .getElement()
              .querySelector(".my-div-names")
              .classList.remove("hide");
          });
          baseLayer.on("mouseout", it => {
            it.sourceTarget
              .getElement()
              .querySelector(".my-div-names")
              .classList.add("hide");
          });
        }
      });
      this.map.addLayer(this.basesGroup);
      //   L.marker([22.15301368697925, 110.97497423601772]).addTo(this.map);
    },
    cleargeoDt() {
      if (this.mm5ditu) {
        this.map.removeLayer(this.mm5ditu);
        this.mm5ditu = null;
      }
    },
    //create geodata
    creategeoDt(data) {
      let arr = [];
      data.forEach(ele => {
        ele.name = ele.country_ + ":" + ele.num;
        ele.latitude = Number(ele.latitude_);
        ele.longitude = Number(ele.longitude_);
        arr.push(ele);
        //   this.baseList.push(ele);
      });
      arr.sort(function (x, y) {
        return x["num"] - y["num"];
      });
      console.log("arr sort ==", arr);
      //add color & create geojson
      let geoarr = [];
      arr.forEach((e, i) => {
        e.color = legendColor[i] || "#57e3f4";
        const index = findIndexByName(
          e.country_,
          mm5geoData.features,
          "properties",
          "NAME"
        );
        if (index > -1) {
          const obj = mm5geoData.features[index];
          Object.assign(obj.properties, e);
          geoarr.push(obj);
        }
      });
      console.log("geoarr ===", geoarr);
      // 加载 geo 5区域地图
      this.loadgeoDt({ type: "FeatureCollection", features: geoarr });
    },
    loadgeoDt(data) {
      this.cleargeoDt();
      this.mm5ditu = L.geoJSON(data, {
        style: function (feature) {
          //   console.log("feature", feature);
          return {
            color: feature.properties.color || "#57e3f4",
            fillOpacity: 0.4,
            weight: 2
            //   dashArray: "10"
          };
        },
        onEachFeature: (feature, layer) => {
          if (this.nowZoom >= 3) {
            return;
          }
          if (feature.properties && feature.properties.name) {
            layer
              .bindTooltip(
                "<div><ul><li>" +
                feature.properties.name +
                " " +
                "</li></ul></div>",
                {
                  direction: "top",
                  offset: L.point(0, -10)
                }
              )
              .on({
                mouseover: this.geohighlight, //鼠标移动上去高亮
                mouseout: this.georesetHighlight, //鼠标移出恢复原样式
                click: this.geoClick
              });
          }
        }
      });
      this.mm5ditu.addTo(this.map);
    },
    geohighlight(e) {
      var layer = e.target;
      //   console.log("color ==", layer.feature.properties.color);
      layer.setStyle({
        weight: 4,
        // color: layer.feature.properties.color,
        fillOpacity: 0.7
      });
    },
    georesetHighlight(e) {
      var layer = e.target;
      //   console.log("color out ==", layer.feature.properties.color);
      layer.setStyle({
        // color: layer.feature.properties.color,
        weight: 2,
        fillOpacity: 0.4
        // dashArray: "10"
      });
    },
    geoClick(e) {
      var dt = e.target.feature.properties;

      console.log("data ==", dt);
      if (this.mode == 7 || this.mode == 5) {
        // 主动放大
        let type = 6;
        if (this.mode == 5) {
          type = 3;
        }
        if (dt.country_) {
          findOrgCompanyByType({
            type: type,
            name: dt.country_
          }).then(data => {
            this.cleargeoDt();
            this.baseList = []; //清空旧的数据
            data.data.map(ele => {
              this.baseList.push(ele);
            });
            this.lockload = true;
            this.map.setView(L.latLng(dt.latitude, dt.longitude), 3);
            this.snqy_baseLoad_h("clz.png", true);
          });
        }
      }
    }
  },
  destroyed() {
    this.cleargeoDt();
  }
};
